import React from 'react';
import { Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
export const Copyright = () => (
  <Text textStyle="p" color="blackAlpha.400" tabIndex={0} aria-live="polite">
    {'© ' + dayjs().year() + ' SpotOn Transact, LLC.'}
  </Text>
);
